<template>
  <div class="contact flex-row">
    <div class="bodyContact flex-col">
      <img
        class="backBtn"
        src="@/assets/images/back.png"
        @click="toBackBlog"
      />

      <div class="bodyBlog">
        <div class="flex-row">
          <!-- <p class="detailTitle">{{ blogDetailValue.title }}</p> -->
          <div class="detailTitle" v-html="blogDetailValue.title"></div>
        </div>

        <div class="detailTime">
          <p class="detailTimeFont1">
            {{ blogDetailValue.publishTime }}
          </p>
        </div>

        <div class="datailContent" v-html="blogDetailValue.message"></div>
      </div>
    </div>
    <div class="hot flex-col">
      <div class="hot-head flex-row">
        <img src="@/assets/images/digitalIcon3.png" alt="" class="hot-img" />
        <div class="hot-title">{{$t("热点资讯")}}</div>
      </div>
      <div class="hot-body flex-col">
        <div
          class="hot-box flex-row"
          v-for="item in hotList"
          :key="item.id"
          @click="toBlogDetail(item)"
        >
          <img :src="item.imageUrl || placeholder" alt="" class="img" />
          <div class="hot-right flex-col">
            <div class="title" v-html="item.title"></div>
            <div class="time">{{ item.publishTime }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getArticleDetail, getRecommends } from "@/config/api.js";
import { MessageBox } from 'element-ui';
export default {
  data() {
    return {
      hotList: [],
      blogDetailValue: [],
    };
  },
  beforeMount() {
    this.param = this.$route.query;
    this.initBlogList(this.param.id);
    this.getRecommendArticles();
  },
  beforeDestroy() {
    document.querySelectorAll("a").forEach((item) => {
      item.removeEventListener("click", this.linksPermissions);
    });
  },
  methods: {
    linksPermissions(e) {
      console.log("=== 禁止a标签跳转直接外部链接 ===", e.target.href);
      e.stopPropagation();
      e.preventDefault();
      if(e.target.href.includes("www.higgs.technology")){
        window.open("http://www.higgs.technology?origin=huniu",'_self',"");
      }else if(e.target.href.includes("huniu.io")){
        window.open(e.target.href,'_self',"");
      }else{
         MessageBox.alert(this.$t('即将离开Dapp打开第三方网页，是否确认打开？'),this.$t('提示'),{
            showCancelButton: true, 
            showClose: false, 
            closeOnClickModal: true, 
            confirmButtonText: '打开',
            cancelButtonText: '取消'
          })
          .then(() => {
              window.parent.postMessage(JSON.stringify({origin:"airdrop.huniu.io",href:e.target.href}), "*");
          })
          .catch(() => {})
      }
    },

    async initBlogList(newsId) {
      var params = { id: newsId };
      getArticleDetail(params).then((res) => {
        if (res.data) {
          let data = res.data;
          this.blogDetailValue = data;
          this.$nextTick(() => {
            document.querySelectorAll("a").forEach((item) => {
              item.addEventListener("click", this.linksPermissions);
            });
          });
        }
      });
    },
    //小编推荐
   async getRecommendArticles() {
      const param = { type: 0, pc: 8 };
      getRecommends(param).then((res) => {
        console.log("getRecommendArticles in detail===", res.data.data);
        if (res.data.data.length>0) {
          this.hotList = res.data.data;
        }
      });
    },
    toBlogDetail(item) {
      this.$router.push({
        path: "/detail",
        query: {
          id: item.id,
        },
      });
      this.initBlogList(item.id);
    },
    toBackBlog() {
      history.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.contact {
  padding: 120px 8% 0 8%;
  height: 100%;
  width: 100%;
  margin: 0 auto 0;
  background: #ffffff;
  .hr {
    width: 100%;
    height: 2px;
    background: #ffffff;

    .hr1 {
      margin: 0 auto;
      width: 100%;
      height: 2px;
      background: rgba(241, 241, 241, 1);
    }
  }

  .bodyContact {
    background: #ffffff;
    height: auto;
    width: 70%;
    margin: 0 auto;

    .backBlog {
      display: flex;
      z-index: 50;
      width: 100%;
      height: 36px;
      overflow-wrap: break-word;
      color: rgba(95, 124, 219, 1);
      font-size: 28px;
      font-family: ArialMT;
      white-space: nowrap;
      line-height: 36px;
      text-align: justify;
      align-self: flex-start;
      margin: 0px 0 0 0;
      padding: 0 2%;
      font-weight: 600px;

      .backBlogFont1 {
        width: auto;
        height: 100%;
        cursor: pointer;
      }
      .backBlogFont2 {
        width: auto;
        height: 100%;
      }
    }

    .bodyBlog {
      width: 100%;
      height: auto;
      padding: 0 5% 5% 5%;
      //
      .detailTitle {
        z-index: 51;
        width: 100%;
        height: auto;
        display: block;
        // overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 28px;
        font-family: Arial-BoldMT;
        line-height: 45px;
        // text-align: justify;
        align-self: center;
        margin: 0px 0;
        font-weight: 600;
      }

      .detailTime {
        display: flex;
        margin: 10px 0;

        .detailTimeFont1 {
          text-align: left;
          width: auto;
          height: 22px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: grey;
          line-height: 22px;
        }
      }

      .datailContent {
        margin: 12px 0 0 0;
        width: 100%;
        height: 100%;
        font-size: 14px;
        line-height: 30px;
        font-family: Arial-BoldMT;
        text-align: justify;
        ::v-deep img {
          max-width: 100%;
        }
      }
    }
  }
  .hot {
    width: 28%;
    // background: pink;
    height: 770px;
    margin: 0 0px 0 3%;

    .hot-head {
      width: 100%;
      height: 30px;
      line-height: 30px;
      font-size: 17px;
      .hot-img {
        padding: 0px 10px 0 0px;
        width: 12%;
        height: 100%;
        object-fit: cover;
      }
      .hot-title {
        margin-left: 10px;
        width: 90%;
        height: 100%;
        color: #1f1f22;
        // background: purple;
      }
      .hot-change {
        width: 50px;
        height: 100%;
        font-size: 15px;
        text-align: right;
      }
    }

    .hot-body {
      margin-top: 20px;
      height: 100%;
      overflow: hidden;
      border: solid 0.08em #eeeeee;
      border-radius: 10px;
      padding: 10px;
    }
    .hot-box {
      padding: 7px 10px;
      height: auto;
      line-height: 20px;

      .img {
        font-size: 18px;
        font-weight: 600;
        height: 100%;
        width: 35%;
        background: #00d764;
        object-fit: cover;
      }
      .hot-right {
        height: 100%;
        text-align: left;
        width: 65%;
        // background: #999999;
        .title {
          font-size: 13px;
          // height: 50px;
          padding: 5px 0 0 8px;
          width: 95%;
          text-align: left;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          cursor: pointer;
        }
        .time {
          margin: 0px 0px 0px 8px;
          line-height: 25px;
          height: 25px;
          color: #a0a0a9;
        }
      }
    }
  }
}
.backBtn {
  height: 40px;
  cursor: pointer;
  position: fixed;
  top: 85%;
  left: 90%;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  padding: 5px;
}
</style>